
import { useState } from 'react';

export default function BookVideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section id="book-video" className="py-24 bg-gradient-to-b from-peach-100 via-lavender-50 to-pink-100 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-20 left-10 w-40 h-40 bg-lavender-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-pink-200/30 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-peach-200/20 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <div className="flex items-center gap-3 bg-gradient-to-r from-lavender-300 to-pink-300 text-gray-800 px-8 py-3 rounded-full text-sm font-bold shadow-lg">
              <i className="ri-video-line text-2xl animate-pulse"></i>
              <span>Watch the Story Come to Life</span>
              <i className="ri-video-line text-2xl animate-pulse"></i>
            </div>
          </div>
          <h2 className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-lavender-400 via-pink-400 to-peach-400 mb-6">
            Book Video
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto font-medium">
            Experience the magic of our stories through this special video presentation! 🎬✨
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative group">
            {/* Decorative frame */}
            <div className="absolute -inset-4 bg-gradient-to-r from-lavender-300 via-pink-300 to-peach-300 rounded-3xl opacity-30 group-hover:opacity-50 transition-opacity blur-xl"></div>
            
            {/* Video container */}
            <div className="relative bg-white p-4 rounded-3xl shadow-2xl border-4 border-white overflow-hidden">
              <div className="aspect-video rounded-2xl overflow-hidden bg-gray-900">
                <iframe
                  src="https://www.youtube.com/embed/nW7ZGWA3JBs?rel=0"
                  title="Book Video - L.J. Boydston"
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-6 -left-6 w-16 h-16 bg-gradient-to-br from-lavender-300 to-lavender-400 rounded-2xl flex items-center justify-center shadow-xl transform -rotate-12 group-hover:rotate-0 transition-transform">
              <i className="ri-play-circle-fill text-3xl text-white"></i>
            </div>
            <div className="absolute -bottom-6 -right-6 w-16 h-16 bg-gradient-to-br from-pink-300 to-pink-400 rounded-2xl flex items-center justify-center shadow-xl transform rotate-12 group-hover:rotate-0 transition-transform">
              <i className="ri-movie-2-fill text-3xl text-white"></i>
            </div>
          </div>

          {/* Feature cards below video */}
          <div className="grid md:grid-cols-3 gap-6 mt-16">
            <div className="bg-gradient-to-br from-lavender-100 via-lavender-50 to-white p-8 rounded-2xl border-3 border-lavender-200 hover:scale-105 hover:shadow-xl transition-all cursor-pointer text-center group">
              <div className="w-14 h-14 bg-gradient-to-br from-lavender-300 to-lavender-400 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform shadow-lg">
                <i className="ri-book-read-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Story Preview</h4>
              <p className="text-sm text-gray-600">Get a sneak peek into the wonderful world of our books!</p>
            </div>

            <div className="bg-gradient-to-br from-pink-100 via-pink-50 to-white p-8 rounded-2xl border-3 border-pink-200 hover:scale-105 hover:shadow-xl transition-all cursor-pointer text-center group">
              <div className="w-14 h-14 bg-gradient-to-br from-pink-300 to-pink-400 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform shadow-lg">
                <i className="ri-heart-3-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Made with Love</h4>
              <p className="text-sm text-gray-600">Every story is crafted with care for young readers!</p>
            </div>

            <div className="bg-gradient-to-br from-peach-100 via-peach-50 to-white p-8 rounded-2xl border-3 border-peach-200 hover:scale-105 hover:shadow-xl transition-all cursor-pointer text-center group">
              <div className="w-14 h-14 bg-gradient-to-br from-peach-300 to-peach-400 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform shadow-lg">
                <i className="ri-share-circle-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Share the Joy</h4>
              <p className="text-sm text-gray-600">Share this video with friends and family!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
